const axiosInstance = require('./axiosInstance');

const register = async (dataReq) => {
    try {
        const response = await axiosInstance.post('/register', dataReq);
        return response.data;
    } catch
        (error) {
        throw error;
    }
}

const checkEmail = async (dataReq) => {
    try {
        const response = await axiosInstance.post('/check-email', dataReq);
        return response.data;
    } catch
        (error) {
        throw error;
    }
}

const checkDuplicate = async (dataReq) => {
    try {
        const response = await axiosInstance.post('/check-duplicate', dataReq);
        return response.data;
    } catch
        (error) {
        throw error;
    }
}


const UserService = {
    register,
    checkEmail,
    checkDuplicate
}

module.exports = UserService;
